<template>
	<div id="app">
		<img class="logo" alt="Vue logo" src="./assets/xsh.png">
<!--		<HelloWorld msg="Welcome to Your Vue.js App" />-->
    <router-view />
	</div>
</template>

<script>
	// import HelloWorld from './components/HelloWorld.vue'

	export default {
		name: 'app',
		components: {

		}
	}
</script>

<style>
	#app {
		font-family: 'MiSans', 'HarmonyOS Sans', 'OPPO Sans', 'PingFang SC';
		/* , cursive; */
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 20px;
	}

	.logo {
		width: 50vw;
	}
</style>
